//  Company Service - Handles API interactions for Comany management

import { post, get } from "../utils/apiUtils";


// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/authentication/create_company`;
const BASE_COMPANY_URL = `/api/v1/persistence/company`;

/**
 * Get all claims Oauths
 * @param {any} domainName - Fetch for what domain
 * @returns {Promise<Object>} Promise resolving to Oauth listing
 */
export const saveCompany = async (payload) => {
  try {
    const response = await post(`${API_URL}`, payload);
    return response;
  } catch (error) {
    console.error('Error saving company:', error);
    throw error;
  }
};


/**
 * Get all claims Oauths
 * @param {any} domainName - Fetch for what domain
 * @returns {Promise<Object>} Promise resolving to Oauth listing
 */
export const getCompaniesByFilter = async (filter = {}, sort ={}, query =null) => {
  try {
    const response = await post(`${BASE_COMPANY_URL}/fetch?${query}`, { filter: filter,sort });
    return response;
  } catch (error) {
    console.error('Error fetching companies:', error);
    throw error;
  }
};

export default {
    saveCompany
}
